module.exports = __webpack_public_path__ + "static/media/classroom-portal.fbf600b2.svg";